<script lang="ts">
	import { Head } from '$lib/components/atoms/Head';
	import { NotFound } from '$lib/components/atoms/NotFound';
	import type { PageData } from './$types';
	import { PUBLIC_BASE_URL } from '$env/static/public';
	import { browser } from '$app/environment';
	import { GtmStore } from '$lib/utils/gtm-store';
	import type { IStaticPage } from '$lib/utils/contentful/types';
	import { StructureUtils } from '$lib/utils/structured-utils';

	export let data: PageData;

	const metaTagData: IStaticPage | null = data?.metaTagData ? JSON.parse(data.metaTagData) : null;

	/******************** GTM EVENT PUSH *************************/
	GtmStore.pushEvent({
		pageCategory: '404'
	});
	/*************************************************************/

	const breadcrumbJson = StructureUtils.getBreadcrumbStructure(
		[
			{
				name: 'Home',
				url: PUBLIC_BASE_URL
			},
			{
				name: '404',
				url: `${PUBLIC_BASE_URL}/404`
			}
		],
		true
	);

	let ldScriptTag = '';

	ldScriptTag = StructureUtils.createScriptTag(JSON.stringify([breadcrumbJson]));

	const seoDetails = {
		title: '404',
		description: metaTagData?.fields?.metaTagSocialDescription || '',
		metaTagSocialTitle: metaTagData?.fields?.metaTagSocialTitle || '',
		metaTagSocialDescription: metaTagData?.fields?.metaTagSocialDescription || '',
		url: '',
		image: metaTagData?.fields?.metaTagSocialImage?.fields.file.url || '',
		metaTagSocialImage: metaTagData?.fields?.metaTagSocialImage?.fields.file.url || '',
		ldScriptTag: ldScriptTag
	};
</script>

<Head appendCompany {seoDetails} />

<NotFound />
